<template>
  <div>
    <div class="p-6 pb-0">
      <BreadCrumbs :navigation="navigation" />
    </div>
    <div class="p-6 pb-0">
      <div class="flex items-center justify-between mb-4">
        <label class="block text-sm font-medium mb-2">{{ $t('go.lista_mail.title') }}</label>
      </div>
      <PageServerTable
        :headers="headers" 
        :items="items" 
        :items-per-page.sync="ipp" 
        :items-per-page-options="ippo" 
        :sort-by="sortby" 
        :items-length="count" 
        :reload-fn="reload"
        :item-value="'id'"

        :page="page"
        show-current-page
        >
        <template #item.customer="{ item }">
            <span>{{ item.company_name ? item.company_name + ' ' + item.cust_supp : '' }}</span>
        </template>
        <template #item.id="{ item }">
            <div class="flex gap-2">
              <Link :href="route('modules.ordini.mail', item.id)" class="bg-blue-400 text-white px-4 py-2 rounded hover:bg-blue-500">{{ $t('go.actions.open') }}</Link>
            </div>
        </template>
      </PageServerTable>
    </div>
  </div>
</template>

<script>
import { Link, router, useForm } from '@inertiajs/vue3';
import BreadCrumbs from '@/Components/BreadCrumbs.vue';
import Pagination from '@/Components/Pagination.vue';
import PageServerTable from '@/Components/PageServerTable.vue';

export default {
  props: ['type', 'items', 'count', 'ippo'],
  components: {
    Link,
    BreadCrumbs,
    Pagination,
    PageServerTable
  },
  data() {
    return {
      search: this.filters?.search || "",
      selected: [],
      //deletions: [],
      showFilters: false,
      headers: [],
      sortby: [],
      ipp: 10,
      page: 1
    };
  },
  computed: {
    navigation() {
      return [
        { name: 'Dashboard', href: route('dashboard') },
        { name: this.$t('go.breadcrumb.gestione_ordini'), href: route('modules.home', 'gestione-ordini') },
        { name: this.$t('go.lista_mail.title'), href: '#' }
      ];
    }
  },
  methods: {
    reload(sortby = undefined, itemsperpage = undefined, page = undefined, afterdeletion = false) {
      /*if (afterdeletion)
      return;*/

        if (sortby) this.sortby = sortby;
        if (itemsperpage) this.ipp = itemsperpage;
        if (page) this.page = page;

        //sortBy e ipp passano solo il valore aggiornato come $event, non si modifica realmente, quindi ricaricare le prop
        router.post(window.location.href, { headers: this.headers, sortby: this.sortby, itemsperpage: this.ipp, page: this.page}, { only: ['items', 'count']});
    },
    applyFilters() {
      this.showFilters = false;
      this.reload();
    },
    loadOrdersData()
    {
      router.post(route('modules.gm.evadiDettagli'), { ids: this.selected.map(x=>x.SaleOrdId)}, { only: ['items', 'count']});
    },
    printDocument(documentId) {
      // Apre la stampa in una nuova finestra
      const printUrl = route('modules.ordini.stampa', { id: documentId });
      window.open(printUrl, '_blank');
    }
  },
  mounted()
  {
    //Primo caricamento
    this.headers = this.$attrs.headers;
    this.ipp = this.$attrs.ipp;
    this.page = this.$attrs.page;
    this.sortby = this.$attrs.sortby;
  }
};
</script>